var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.68,16.5,33,30.82,30.82,33,16.5,18.68,2.18,33,0,30.82,14.32,16.5,0,2.18,2.18,0,16.5,14.32,30.82,0,33,2.18Z"}));
}

Close.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 33 33"};

module.exports = Close;

Close.default = Close;
